// Google Sheets Configuration
// Replace YOUR_SCRIPT_URL with your actual Google Apps Script deployment URL

export const SHEETS_CONFIG = {
  // Your Google Apps Script deployment URL
  SCRIPT_URL: 'https://script.google.com/macros/s/AKfycbxgLy7JM74ZiKKbUhPdwymi9vjtmkfjsXzYwFRXd-8gV8eVQo5HIDH_-rnQ9_nodHb2/exec',
  
  // API endpoints
  ENDPOINTS: {
    EVENTS: '?action=getEvents',
    TIME_SLOTS: '?action=getTimeSlots',
    REGISTRATIONS: '?action=getRegistrations',
    FEEDBACK: '?action=getFeedback'
  },
  
  // Default Google Sheets Event ID — California Jul 18, 2026 (see event-registration-config.js for IDs)
  DEFAULT_EVENT_ID: 12,
  
  // Maximum registrations per person
  MAX_REGISTRATIONS_PER_PERSON: 2,
  
  // Maximum slots per registration
  MAX_SLOTS_PER_REGISTRATION: 1
};

// Helper function to build full URLs
export const buildUrl = (endpoint) => {
  return `${SHEETS_CONFIG.SCRIPT_URL}${endpoint}`;
};

// Helper function to get events URL
export const getEventsUrl = () => {
  return buildUrl(SHEETS_CONFIG.ENDPOINTS.EVENTS);
};

// Helper function to get time slots URL
export const getTimeSlotsUrl = (eventId) => {
  return buildUrl(`${SHEETS_CONFIG.ENDPOINTS.TIME_SLOTS}&eventId=${eventId}`);
};

// Helper function to get registrations URL
export const getRegistrationsUrl = () => {
  return buildUrl(SHEETS_CONFIG.ENDPOINTS.REGISTRATIONS);
};

// Helper function to get feedback URL
export const getFeedbackUrl = () => {
  return buildUrl(SHEETS_CONFIG.ENDPOINTS.FEEDBACK);
};
